import React from "react";
import PropTypes from "prop-types";
import { css } from "react-emotion";
import { Select } from "components";

const propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  }),
  form: PropTypes.shape({
    touched: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
  }),
  label: PropTypes.string,
  hideError: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelName: PropTypes.string.isRequired,
};

const CustomInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  hideError,
  items,
  labelName,
}) => {
  const invalid = touched[field.name] && errors[field.name];
  const invalidClass = invalid ? "invalid" : "";

  return (
    <div className={`${wrapperClass} ${invalidClass}`}>
      <Select
        items={items}
        onChange={val => setFieldValue(field.name, val.id)}
        placeholder={label}
        selected={field.value}
        labelName={labelName}
        floatingLabel={true}
      />
      {hideError !== true && <div className={errorClass}>{invalid && errors[field.name]}</div>}
    </div>
  );
};

CustomInput.propTypes = propTypes;
export default CustomInput;

const wrapperClass = css`
  position: relative;
`;

const errorClass = css`
  font-size: 12px;
  font-weight: 600;
  color: #fc3666;
  margin-left: 10px;
  margin-top: 0;
  margin-bottom: 3px;
  min-height: 31px;
`;



// WEBPACK FOOTER //
// ./src/components/form/CustomSelect.jsx